//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
//Action
import * as timelineAction from '../action/timelineAction';

//Icon
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
//Part
import PartCheckbox from './PartCheckbox';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Comp extends React.Component {
  constructor(props) {
    super(props);


    this.state = {
      footprint: null,
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.open === false && this.props.open === true) {
      let lsObj = JSON.parse(localStorage.getItem('TimelineCondition'));
      this.setState({
        footprintFilter: lsObj.footprintFilter,
      });
    }
  }




  _submit() {
    var obj = {
      footprintFilter: (this.state.footprintFilter) ? 'age': '',
    };
    localStorage.setItem('TimelineCondition', JSON.stringify(obj));
    this.props.timelineListGet(1);
    this.props.close();

  }



	render() {
		return (
      <Dialog
        fullScreen
        open={this.props.open}
        onClose={ () => this.props.close() }
        TransitionComponent={Transition}
        style={{maxWidth:'600px', margin:'auto'}}
        scroll='paper'
      >

        <div style={{position:'fixed',top:'0px',left:'0px',width:'100%' ,zIndex:'101'}}>
          <div style={{maxWidth:'600px', margin:'auto', background:'#FFF'}} className='shadow'>
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <IconButton
                  onClick={ () => this.props.close() }
                  >
                  <ArrowBackIosIcon />
                </IconButton>
                タイムラインの設定
              </div>

            </div>
          </div>
        </div>

    			<div
            style={{
              width:'100%',
              background:'#FFF',
              paddingTop:'40px',
              paddingBottom:'60px',
            }}
          >


          <div style={{padding:'3%'}}>
            <div style={{padding:'3%'}}>
              <h3>
                足あと
              </h3>

              <PartCheckbox
                value={this.state.footprintFilter}
                checked={this.state.footprintFilter}
                click={ (e) => this.setState({footprintFilter: (this.state.footprintFilter ? false: true)}) }
              >
                <span>希望年齢の足あとだけを表示</span>
              </PartCheckbox>
            </div>
          </div>

          <div style={{position:'fixed',bottom:'0',left:'0px',width:'100%' ,zIndex:'101'}}>
            <div style={{maxWidth:'600px', margin:'auto', background:'rgba(0,0,0,0.3)'}}>
              <div style={{padding:'10px'}}>
                <Button
                  variant="contained"
                  color='primary'
                  onClick={ () => this._submit() }
                  style={{width: '100%', fontSize:'1.2em'}}
                >
                  設定する
                </Button>
              </div>
            </div>
          </div>
  			</div>
      </Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...timelineAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
